import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  setPersistence,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { STAFF_EMAIL, getAuthorizedUserRole } from '../utils/authConfig';
import '../styles.css';

function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const finishLogin = async (user, expectedRole) => {
    const role = await getAuthorizedUserRole(user, true);
    if (role !== expectedRole) {
      await signOut(auth);
      throw new Error('這個帳號沒有後台使用權限');
    }
    onLogin(role);
    navigate('/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!password) {
      setErrorMessage('請輸入密碼');
      return;
    }

    try {
      setIsLoading(true);
      setErrorMessage('');
      await setPersistence(auth, browserLocalPersistence);
      const credential = await signInWithEmailAndPassword(auth, STAFF_EMAIL, password);
      await finishLogin(credential.user, 'staff');
    } catch (error) {
      console.error('工作人員登入失敗:', error);
      setErrorMessage(error.code === 'auth/operation-not-allowed'
        ? '工作人員登入尚未啟用，請由管理員完成初次設定'
        : '密碼錯誤或尚未設定');
      setPassword('');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    if (isLoading) return;
    try {
      setIsLoading(true);
      setErrorMessage('');
      await setPersistence(auth, browserLocalPersistence);
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: 'select_account' });
      const credential = await signInWithPopup(auth, provider);
      await finishLogin(credential.user, 'admin');
    } catch (error) {
      console.error('管理員 Google 登入失敗:', error);
      if (error.code !== 'auth/popup-closed-by-user') {
        setErrorMessage(error.message || 'Google 登入失敗，請稍後再試');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2>工作人員登入</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="輸入工作人員密碼"
          autoComplete="current-password"
        />
        <button type="submit" disabled={isLoading}>
          {isLoading ? '驗證中...' : '密碼登入'}
        </button>
      </form>
      <div style={{ width: '100%', maxWidth: '300px', textAlign: 'center', margin: '1rem 0', color: '#94a3b8' }}>
        或
      </div>
      <button
        type="button"
        onClick={handleGoogleLogin}
        disabled={isLoading}
        style={{ width: '100%', maxWidth: '300px', background: '#fff', color: '#334155', border: '1px solid #cbd5e1' }}
      >
        管理員使用 Google 登入
      </button>
      {errorMessage && (
        <div style={{ width: '100%', maxWidth: '300px', color: '#b91c1c', marginTop: '1rem', lineHeight: 1.5 }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
}

export default Login;
